module.exports = __webpack_public_path__ + "static/img/FR.04d69a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/FR.svg
// module id = XUkH
// module chunks = 1